import { render, staticRenderFns } from "./CatalogTree.vue?vue&type=template&id=252a6f5e"
import script from "./CatalogTree.vue?vue&type=script&lang=js"
export * from "./CatalogTree.vue?vue&type=script&lang=js"
import style0 from "./CatalogTree.vue?vue&type=style&index=0&id=252a6f5e&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports